import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { i18nextKeys } from 'Lang/i18nextKeys';
import i18nextTranslate from 'Lang/i18nextTranslate';
import { UiContext } from 'States/ui/uiState';
import websiteIcon from 'Assets/images/website.svg';
import linkedinIcon from 'Assets/images/linkedin.svg';
import twitterIcon from 'Assets/images/twitter.svg';
import instagramIcon from 'Assets/images/instagram.svg';
import youtubeIcon from 'Assets/images/youtube.svg';

const CustomFooter = () => {
  const { breakpoints: { xl } } = useContext(UiContext);
  return (
    <div
      className="px-16 md:px-0"
      style={{
        width: "100%",
        maxWidth: "940px",
        paddingTop: "60px"
      }}
    >
      <div className='flex justify-end items-center gap-32'>
        <a
          href={i18nextTranslate(i18nextKeys.customFooterSocialMediaLinksLinkedin) || undefined}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={linkedinIcon}
            alt="linkedin"
            data-qa="icon-linkedin"
            style={{ width: "34px" }}
          />
        </a>
        <a
          href={i18nextTranslate(i18nextKeys.customFooterSocialMediaLinksTwitter) || undefined}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={twitterIcon}
            alt="twitter"
            data-qa="icon-twitter"
          />
        </a>
        <a
          href={i18nextTranslate(i18nextKeys.customFooterSocialMediaLinksInstagram) || undefined}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={instagramIcon}
            alt="instagram"
            data-qa="icon-instagram"
          />
        </a>
        <a
          href={i18nextTranslate(i18nextKeys.customFooterSocialMediaLinksYoutube) || undefined}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={youtubeIcon}
            alt="youtube"
            data-qa="icon-youtube"
          />
        </a>
      </div>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "40px",
          backgroundColor: "#e4ebf3",
          height: "1px",
          width: "100%"
        }}
      ></div>
      <div
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: xl ? "10px" : "14px",
          lineHeight: "20px",
          color: "#333"
        }}
      >
        {i18nextTranslate(i18nextKeys.customFooterText)}
      </div>
      <div className='flex justify-between items-center mt-6'>
        <div
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: xl ? "10px" : "14px",
            lineHeight: "20px",
            color: '#333'
          }}
        >
          {i18nextTranslate(i18nextKeys.customFooterCopyright, { currentYear: new Date().getFullYear() })}
        </div>
        <div
          className='flex items-center gap-24'
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: xl ? "10px" : "14px",
            lineHeight: "20px",
            color: '#333'
          }}
        >
          {i18nextTranslate(i18nextKeys.customFooterLinks, { returnObjects: true }).map(
            (link, index) => {
              if (!link.enabled || !link.text) {
                return null;
              }
              return link.external ? (
                <a
                  key={`custom-footer-link-${index}`}
                  href={link.url || link.path || undefined}
                  target={link.newTab ? "_blank" : "_self"}
                >
                  {link.text}
                </a>
              ) : (
                <Link
                  key={`custom-footer-link-${index}`}
                  to={link.path}>{link.text}
                </Link>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomFooter;
